/**
 *
 * Vue component (Vue.js 2.0) or directive (Vue.js 1.0) allowing drag-and-drop and synchronization with view model array.
 * Based on and offering all features of Sortable.js
 *
 * */

import Vue from 'vue'
import draggable from 'vuedraggable'

Vue.use(draggable)
